var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import AccordionWrapper from './presentational/accordionWrapper';
import ListItems from './presentational/listItems';
var AccordionLabel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 1rem;\n    padding: 0 0.6rem 0.6rem;\n    border-bottom: 1px solid #ddd;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    width: 100%;\n    font-size: 1rem;\n    font-weight: bold;\n    text-align: left;\n    color: #007bc7;\n"], ["\n    margin-top: 1rem;\n    padding: 0 0.6rem 0.6rem;\n    border-bottom: 1px solid #ddd;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    width: 100%;\n    font-size: 1rem;\n    font-weight: bold;\n    text-align: left;\n    color: #007bc7;\n"])));
export var Accordion = function (_a) {
    var labelText = _a.labelText, title = _a.title, items = _a.items, updateItemClass = _a.updateItemClass;
    var getItemName = function (id) {
        var name = '';
        items.map(function (item) {
            if (item.itemId === id) {
                name = item.itemName;
            }
        });
        return name;
    };
    return (_jsxs(_Fragment, { children: [labelText && _jsx(AccordionLabel, { children: labelText }, void 0), _jsx(AccordionWrapper, __assign({ title: title, itemLength: items.length }, { children: _jsx(_Fragment, { children: items.map(function (item, index) {
                        return (_jsx(ListItems, { itemId: item['itemId'], itemName: getItemName(item['itemId']), handleClickCallback: updateItemClass }, index));
                    }) }, void 0) }), void 0)] }, void 0));
};
Accordion.displayName = 'NekoAccordion';
var templateObject_1;
